"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var color_1 = __importDefault(require("color"));
var styles = function (theme, isMobile) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    return (0, styles_1.makeStyles)({
        centered: {
            display: 'flex',
            justifyContent: 'center'
        },
        body1High: __assign(__assign({}, theme.typography.body1), { color: theme.palette.text.primary }),
        body2High: __assign(__assign({}, theme.typography.body2), { color: theme.palette.text.primary }),
        body2Medium: __assign(__assign({}, theme.typography.body2), { color: theme.palette.text.secondary }),
        subtitle2High: __assign(__assign({}, theme.typography.subtitle2), { color: theme.palette.text.primary }),
        subtitleMedium: {
            color: theme.palette.text.secondary
        },
        bold: {
            fontWeight: 'bold'
        },
        dateCell: (_a = {
                minWidth: 108
            },
            _a[theme.breakpoints.down('xs')] = {
                minWidth: 65,
                maxWidth: 65
            },
            _a),
        earnings: (_b = {},
            _b[theme.breakpoints.down('xs')] = {
                minWidth: 55,
                padding: theme.spacing()
            },
            _b),
        activityPoints: (_c = {
                minWidth: 102
            },
            _c[theme.breakpoints.down('xs')] = {
                minWidth: 55,
                maxWidth: 55
            },
            _c),
        description: (_d = {},
            _d[theme.breakpoints.down('xs')] = {
                padding: theme.spacing(),
                maxWidth: 85,
                minWidth: 65,
                wordWrap: 'break-word'
            },
            _d),
        tableRow: {
            '&:hover': {
                backgroundColor: (0, color_1.default)(theme.palette.common.black)
                    .alpha(0.1)
                    .rgb()
                    .string() + ' !important'
            }
        },
        pointsAmount: {
            minWidth: 102
        },
        rewardDetail: (_e = {
                maxWidth: 340
            },
            _e[theme.breakpoints.down('xs')] = {
                maxWidth: 55,
                padding: theme.spacing()
            },
            _e),
        tabSection: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between'
        },
        title: (_f = {
                maxWidth: 720,
                wordBreak: 'break-all'
            },
            _f[theme.breakpoints.down('xs')] = {
                padding: theme.spacing()
            },
            _f),
        link: __assign(__assign({}, theme.typography.body2), { cursor: 'pointer', color: 'inherit', display: 'flex', alignItems: 'center', '&:focus': {
                backgroundColor: (0, color_1.default)(theme.palette.common.black)
                    .alpha(0.1)
                    .rgb()
                    .string()
            } }),
        couponLink: (_g = {
                border: '1px solid rgba(0, 87, 184, 1)',
                borderRadius: '20px',
                padding: theme.spacing(),
                color: theme.palette.primary.main,
                maxWidth: '135px',
                textAlign: 'center',
                alignItems: 'center',
                justifyContent: 'center'
            },
            _g[theme.breakpoints.down('xs')] = {
                maxWidth: 80,
                padding: theme.spacing()
            },
            _g),
        couponDetail: (_h = {
                maxWidth: '135px'
            },
            _h[theme.breakpoints.down('xs')] = {
                maxWidth: 80,
                padding: theme.spacing()
            },
            _h),
        downloadIcon: {
            color: theme.palette.primary.main
        },
        underline: {
            borderBottomColor: theme.palette.text.primary,
            borderBottom: '1px solid',
            marginBottom: theme.spacing()
        },
        prizeItem: {
            marginLeft: theme.spacing()
        },
        entry: {
            borderColor: theme.palette.primary.main,
            border: '1px solid',
            paddingRight: 4,
            paddingLeft: 4
        },
        pending: {
            color: theme.palette.error.main
        },
        points: (_j = {
                display: 'flex',
                flexDirection: 'row'
            },
            _j[theme.breakpoints.down('xs')] = {
                flexDirection: 'column'
            },
            _j),
        pendingPoints: (_k = {
                marginLeft: theme.spacing(),
                marginTop: theme.spacing()
            },
            _k[theme.breakpoints.down('xs')] = {
                marginRight: theme.spacing(),
                marginLeft: 0
            },
            _k),
        showFlexForPendingPoints: {
            display: 'flex',
            alignItems: !isMobile ? 'center' : undefined,
            flexDirection: !isMobile ? undefined : 'column'
        },
        pendingTotalPoints: {
            display: 'flex',
            flexDirection: 'row'
        },
        dialogBackdrop: {
            backgroundColor: (0, color_1.default)(theme.palette.grey[500])
                .alpha(0.8)
                .rgb()
                .string()
        },
        dialog: {
            backgroundColor: theme.palette.background.default,
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        },
        dialogContent: {
            padding: 0
        },
        dialogHeader: {
            marginBottom: theme.spacing(2),
            color: theme.palette.text.primary
        },
        dialogDate: {
            marginBottom: theme.spacing()
        },
        dialogImage: (_l = {
                width: 140,
                height: 140,
                marginRight: theme.spacing(3)
            },
            _l[theme.breakpoints.down('md')] = {
                width: 100,
                height: 100
            },
            _l),
        dialogGameContent: {
            display: 'flex',
            flexDirection: 'row'
        },
        dialogGameDetails: {
            display: 'flex',
            flexDirection: 'column'
        },
        dialogGameName: {
            marginTop: theme.spacing(),
            marginBottom: theme.spacing(2)
        },
        dialogActions: {
            marginBottom: theme.spacing(3)
        },
        noBottomSpacing: {
            paddingBottom: '0 !important'
        },
        noTopSpacing: {
            paddingTop: '0 !important'
        },
        bonus: {
            display: 'inline',
            marginRight: theme.spacing(),
            verticalAlign: 'middle'
        },
        bonusPoints: {
            fontStyle: 'italic',
            display: 'inline',
            marginRight: theme.spacing()
        },
        pastHistoryBtn: {
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: theme.spacing(2)
        },
        pastHistoryButton: {
            padding: 0,
            '&:hover,&:focus': {
                color: "".concat(theme.palette.primary.dark, " !important"),
                backgroundColor: 'transparent !important'
            }
        },
        playButton: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
            borderRadius: theme.spacing(1)
        },
        superBonus: {
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer'
        },
        superBonusText: {
            fontWeight: 'bold'
        },
        star: {
            width: 40,
            height: 40,
            marginTop: theme.spacing(1),
            marginRight: theme.spacing(1)
        },
        descriptionIcon: {
            display: 'inline-block',
            height: '3em',
            verticalAlign: 'middle'
        },
        selectedFilter: {
            '& .MuiButton-contained': {
                backgroundColor: theme.palette.secondary.main,
                border: 'none',
                color: theme.palette.grey[700]
            }
        }
    });
};
exports.default = styles;
//# sourceMappingURL=styles.js.map